// src/RetroPGF.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import GlobalStyle from '../GlobalStyles';
import Footer from '../components/Footer';
import InfoBanner_RetroPGF from '../components/InfoBanner_RetroPGF';
import RetroPGFSec2 from '../components/RetroPGFSec2';
import RetroPGFSec3 from '../components/RetroPGFSec3';
import RetroPGFSec4 from '../components/RetroPGFSec4';



const Container = styled.div`
  max-width: 100%;
  margin:0px;
  padding: 0px;
  background-color:#000000;
`;


function RetroPGF() {



  return (

    <Container>
   
        <Navbar />
        <InfoBanner_RetroPGF /> 
        <RetroPGFSec2 />
        <RetroPGFSec3 />
        <RetroPGFSec4 />
     

        <Footer /> 

    </Container>

  );
}

export default RetroPGF;